"use client";
import * as React from "react";
const SvgStarOutlineOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 6.216-5.752-.49L8 .5 5.752 5.734 0 6.216 4.368 9.95 3.056 15.5 8 12.555l4.944 2.945-1.304-5.55L16 6.216Zm-8 4.863L4.992 12.87l.8-3.379-2.656-2.274 3.504-.3L8 3.737l1.368 3.19 3.504.3L10.216 9.5l.8 3.379L8 11.079Z" }));
export {
  SvgStarOutlineOutlined as default
};
